import { Route, Routes } from "react-router";

import Admin from "./pages/admin";
import Home from "./pages/home";

import {
  IsAuthRoute,
  ProtectedRoute,
} from "./components/navigation/PrivateRoute.component";
import { Fornecedores } from "./pages/fornecedores";
import Pacotes from "./pages/pacotes";

import Contato from "./pages/contato";
import { DashboardSonhos } from "./pages/dashboard-sonhos";
import { SlugSonhosRealizados } from "./pages/slug-sonhos-realizados";
import SlugViagem from "./pages/slugViagem";
import SonhosRealizados from "./pages/sonhos-realizados";
import Viagens from "./pages/viagens";

const Rotas = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/viagens" element={<Viagens />} />
      <Route path="/viagens/:slug" element={<SlugViagem />} />
      <Route path="/contato" element={<Contato />} />
      <Route path="/sonhos-realizados" element={<SonhosRealizados />} />
      <Route path="/sonhos-realizados/:id" element={<SlugSonhosRealizados />} />
      <Route path="/admin" element={<IsAuthRoute />}>
        <Route path="/admin" element={<Admin />} />
      </Route>
      <Route path="/admin/dashboard" element={<ProtectedRoute />}>
        <Route path="/admin/dashboard" element={<Pacotes />} />
        <Route
          path="/admin/dashboard/sonhos-realizados"
          element={<DashboardSonhos />}
        />
        <Route
          path="/admin/dashboard/fornecedores"
          element={<Fornecedores />}
        />
      </Route>
    </Routes>
  );
};

export default Rotas;
